/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default props => (
    <SvgIcon {...props}>
        <path fillRule="evenodd" d="M6 6h12v12H6z" />
    </SvgIcon>
);
